import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Box, Typography } from '@mui/material';
import { DonutChart } from '../../../shared';
import { SEGMENT_CHART_OPTIONS, CHANNEL_CHART_OPTIONS } from './constants';
import DonutChartSkeleton from '../../../shared/skelton/donutChartSkeleton';
import { capitalizeFirstLetter } from '../../../../utility';
import { REGENERON_COMPANY_ID } from '../../../../constants';
import NpiEngagedPieChart from './npiEngagedPieChart';

const showNpiEngagement = [64,66,161,140];

const TotalEngagement = () => {
    const {
        channelEngagement, 
        segmentEngagement,
        digitalEngagement,
        combinedSegment,
        isLoading 
    } = useSelector((state) => state.totalEngagement);
    const { company } = useSelector((state) => state.company);
    
    return (
        <><Grid container spacing={2}>
            {/* Engagement Channels */}
            <Grid item xs={showNpiEngagement.includes(company.id) ? 4 : 6}>
                <Box className='container-p-24-br-16 bg-gray-50 height-100'>
                    <Box>
                        <Typography className='text-md-semi-bold gray-900' >
                            {company.id === REGENERON_COMPANY_ID ? 'Digital Engagement': 'Engagement Channels'}
                        </Typography>
                    </Box>
                    <Box className="wh-70 align_center" id="total-engagement-channels">
                        {
                            (company.id === REGENERON_COMPANY_ID ? isLoading : isLoading ) 
                                ? <DonutChartSkeleton/> 
                                : <DonutChart
                                    chartOptions={company.id === REGENERON_COMPANY_ID ?
                                        {
                                            ...SEGMENT_CHART_OPTIONS, 
                                            labels: digitalEngagement.labels.map(item => capitalizeFirstLetter(item)), 
                                            colors: digitalEngagement.colors 
                                        }
                                        : { ...CHANNEL_CHART_OPTIONS, labels: channelEngagement.labels }}
                                    chartSeries={company.id === REGENERON_COMPANY_ID ? digitalEngagement.series : channelEngagement.series}
                                />
                        }
                    </Box>
                </Box>
            </Grid>
            {/* Physician Engagement Segments */}
            <Grid item xs={showNpiEngagement.includes(company.id) ? 4 : 6}>
                <Box className='container-p-24-br-16 bg-gray-50 height-100'>
                    <Box>
                        <Typography className='text-md-semi-bold gray-900' >
                            Physician Engagement Segments
                        </Typography>
                    </Box>
                    <Box className="wh-70 align_center" id="total-engagement-segments">
                        {
                            isLoading 
                                ? <DonutChartSkeleton/> 
                                : <DonutChart
                                    chartName="Physician Engagement Segments"
                                    chartOptions={{
                                        ...SEGMENT_CHART_OPTIONS,
                                        labels: segmentEngagement.labels,
                                        colors: segmentEngagement.colors,
                                        extraData: company.id === 67 ? combinedSegment : {}
                                    }}
                                    chartSeries={segmentEngagement.series}
                                    companyId={company.id}
                                />
                              
                        }
                    </Box>
                </Box>
            </Grid>
            {
                showNpiEngagement.includes(company.id) && <Grid item xs={4}>
                    <NpiEngagedPieChart/>
                </Grid>
            }
           
        </Grid>
        </>
    );
};

export default TotalEngagement;